import SectionCard from "../ui/SectionCard";
import SupplyNumberInput from "./Supplynumberinput";
import { supplierOptions, paymentMethodOptions, meterTypeOptions } from "../../data/formDefaults";
 
function FieldError({ message }) {
  if (!message) return null;
  return <p className="text-red-500 text-[11px] mt-1">{message}</p>;
}
 
function inputCls(hasError) {
  return `
    flex-1 border px-3 py-2 text-sm text-gray-900 bg-white
    focus:outline-none focus:ring-1
    ${hasError ? "border-red-500 focus:ring-red-400" : "border-gray-400 focus:ring-blue-500"}
  `;
}
 
function selectCls(hasError) {
  return `
    flex-1 border px-3 py-1 text-sm text-gray-900 bg-white
    focus:outline-none focus:ring-1
    ${hasError ? "border-red-500 focus:ring-red-400" : "border-gray-400 focus:ring-blue-500"}
  `;
}
 
export default function ElectricitySection({ form, errors = {}, setField }) {
 
  // ── Auto-fill MPAN (General Info) when Get is clicked ──
  // const handleFetched = (data) => {
  //   if (data.mpan_core) {
  //     setField("mpan")({ target: { value: data.mpan_core } });
  //   }
  // };
 
  const handleFetched = (data) => {
  setField("mpan")({
    target: { name: "mpan", value: data.mpan_core || "" },
  });
};
 
  return (
    <SectionCard title="ELECTRICITY">
      <div className="border border-gray-300 bg-[#dbe9f5] p-4 space-y-3">
 
        {/* CURRENT SUPPLIER */}
        <div className="flex items-start gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Current Supplier *</label>
          <div className="flex-1">
            <select
              name="elecSupplier"
              value={form.elecSupplier}
              onChange={(e) => {
                setField("elecSupplier")(e);
                if (form.validationType === "Electricity + Gas") setField("gasSupplier")(e);
              }}
              className={selectCls(errors.elecSupplier)}
            >
              <option value="">Select Supplier</option>
              {supplierOptions.map((item) => <option key={item} value={item}>{item}</option>)}
            </select>
            <FieldError message={errors.elecSupplier} />
          </div>
        </div>
 
        {/* CUSTOMER ACCOUNT */}
        <div className="flex items-center gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700">Customer Account No</label>
          <input
            name="elecAccount"
            type="text"
            value={form.elecAccount}
            onChange={setField("elecAccount")}
            className={inputCls(false)}
          />
        </div>
 
        {/* MONTH & YEAR */}
        <div className="flex items-center gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700">Month And Year</label>
          <input
            name="elecMonthYear"
            type="month"
            value={form.elecMonthYear || ""}
            onChange={setField("elecMonthYear")}
            className={inputCls(false)}
          />
        </div>
 
        {/* CONTRACT END DATE */}
        <div className="flex items-start gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Contract End Date *</label>
          <div className="flex-1">
            <input
              name="elecContractEnd"
              type="date"
              value={form.elecContractEnd}
              onChange={setField("elecContractEnd")}
              className={inputCls(errors.elecContractEnd)}
            />
            <FieldError message={errors.elecContractEnd} />
          </div>
        </div>
 
        {/* PAYMENT METHOD */}
        <div className="flex items-start gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Payment Method </label>
          <div className="flex-1">
            <select
              name="elecPayment"
              value={form.elecPayment}
              onChange={setField("elecPayment")}
              className={selectCls(errors.elecPayment)}
            >
              <option value="">Select PaymentMethod</option>
              {paymentMethodOptions.map((item) => <option key={item} value={item}>{item}</option>)}
            </select>
           
          </div>
        </div>
 
        {/* METER TYPE */}
        {/* <div className="flex items-start gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Meter Type *</label>
          <div className="flex-1">
            <select
              name="elecMeterType"
              value={form.elecMeterType}
              onChange={setField("elecMeterType")}
              className={selectCls(errors.elecMeterType)}
            >
              <option value="">Select Meter</option>
              {meterTypeOptions?.map((item) => <option key={item} value={item}>{item}</option>)}
            </select>
            <FieldError message={errors.elecMeterType} />
          </div>
        </div> */}
 
         <div className="flex items-start gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Meter Type </label>
          <div className="flex-1">
            <select
              name="elecMeterType"
              value={form.elecMeterType}
              onChange={setField("elecMeterType")}
              className={selectCls(errors.elecMeterType)}
            >
              <option value="">Select Meter</option>
              {meterTypeOptions?.map((item) => <option key={item} value={item}>{item}</option>)}
            </select>
         
          </div>
        </div>
 
        {/* CURRENT RATE */}
        <div className="border-t border-cyan-500 pt-3 mt-2">
          <h3 className="text-[13px] font-bold uppercase text-gray-700 mb-3">CURRENT RATE</h3>
          {[
            { label: "Day",             field: "elecDayRate" },
            { label: "Night",           field: "elecNightRate" },
            { label: "Eve/Weekends",    field: "elecEveRate" },
            { label: "Standing Charge", field: "elecStandingCharge" },
            { label: "EAC *",             field: "elecEseRate" }   // ← add this
          ].map(({ label, field }) => (
            <div key={field} className="flex items-center gap-3 mb-2">
              <label className="w-44 text-[12px] text-gray-700">{label}</label>
             
              <input
                name={field}
                type="text"
                value={form[field] || ""}
                onChange={setField(field)}
             className={inputCls(!!errors[field])}
              />
                <FieldError message={errors[field]} />
            </div>
           
          ))}
        </div>
 
        {/* SUPPLY NO — mpan_top_line */}
        {/* <div className="flex items-start gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Supply No *</label>
          <SupplyNumberInput
            value={form.elecSupplyNumber}
            onChange={setField("elecSupplyNumber")}
            onClear={() => {
              setField("elecSupplyNumber")({
                target: { name: "elecSupplyNumber", value: "" },
              });
              setField("mpan")({ target: { value: "" } });
            }}
            onFetched={handleFetched}
            error={errors.elecSupplyNumber}
          />
        </div> */}
 
        <div className="flex items-start gap-3">
  <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Supply No *</label>
  <SupplyNumberInput
    value={form.elecSupplyNumber}
    onChange={setField("elecSupplyNumber")}
    onClear={() => {
      setField("elecSupplyNumber")({
        target: { name: "elecSupplyNumber", value: "" },
      });
      setField("mpan")({ target: { name: "mpan", value: "" } });
    }}
    onFetched={handleFetched}
    error={errors.elecSupplyNumber || errors.mpan}
  />
</div>
 
        {/* AVERAGE BILL */}
        <div className="flex items-start gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Average Bill Amount</label>
          <div className="flex-1">
            <div className="flex gap-2">
              <input
                name="elecAvgBill"
                type="text"
                value={form.elecAvgBill || ""}
                onChange={setField("elecAvgBill")}
                className={`flex-1 border px-3 py-2 text-sm text-gray-900 bg-white focus:outline-none focus:ring-1 ${errors.elecAvgBill ? "border-red-500 focus:ring-red-400" : "border-gray-400 focus:ring-blue-500"}`}
              />
              <select
                value={form.elecBillType || ""}
                onChange={setField("elecBillType")}
                className="w-26 border border-gray-400 text-gray-900 px-3 py-2 text-sm "
              >
                <option value="MONTHLY">MONTHLY</option>
                <option value="QUARTERLY">QUARTERLY</option>
              </select>
            </div>
           
          </div>
        </div>
 
        {/* BILL RANGE */}
        <div className="flex items-center gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700">Average Bill Range</label>
          <select
            value={form.elecBillRange || ""}
            onChange={setField("elecBillRange")}
            className="flex-1 border border-gray-400 px-3 py-2 text-sm text-gray-900 bg-white"
          >
            <option value="">Select</option>
             <option value="£0 - £500">£0 - £500</option>
    <option value="£500 - £1,000">£500 - £1,000</option>
    <option value="£1,000 - £2,500">£1,000 - £2,500</option>
    <option value="£2,500 - £5,000">£2,500 - £5,000</option>
    <option value="£5,000 - £10,000">£5,000 - £10,000</option>
    <option value="£10,000 - £25,000">£10,000 - £25,000</option>
    <option value="£25,000 - £50,000">£25,000 - £50,000</option>
    <option value="£50,000+">£50,000+</option>
          </select>
        </div>
 
        {/* MSN */}
        <div className="flex items-center gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700">MSN No</label>
          <input
            name="elecMSN"
            type="text"
            value={form.elecMSN || ""}
            onChange={setField("elecMSN")}
            className={inputCls(false)}
          />
        </div>
 
      </div>
    </SectionCard>
  );
}
 
